<style>

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

</style>

<div class="bg">
  <div class="title-signup">Create a username</div>
  <div class="margin"><input type="text" bind:value="{username}"></div>
  <div class="margin small"></div>
  
  <div class="has-buttons"></div>
  
</div>

<div class="next">
  <button on:click="{next}">Next</button>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

let username = "alisonjames";

function next() {
  push("/signup/profile/personal/password");
}


</script>